// extracted by css-extract-rspack-plugin
export default {"licensedModifiedSize":"o651C7SuSzwYwCOp"};